import { CheckCircle2 } from "lucide-react";

export type PaymentVerificationStatus = "verifying" | "success" | "idle";

interface PaymentVerificationOverlayProps {
  open: boolean;
  status: PaymentVerificationStatus;
}

/** Full-screen overlay shown after Razorpay success while payment is verified on the server */
export default function PaymentVerificationOverlay({
  open,
  status,
}: PaymentVerificationOverlayProps) {
  if (!open || status === "idle") {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[1000] flex flex-col items-center justify-center bg-black/70 backdrop-blur-[3px] transition-all">
      {status === "verifying" ? (
        <>
          <div className="mb-4 h-16 w-16 animate-spin rounded-full border-4 border-[#D4A017] border-t-transparent" />
          <p className="text-lg font-bold text-[#D4A017]">
            Verifying your payment...
          </p>
        </>
      ) : (
        <>
          <div className="animate-in zoom-in mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-emerald-500/10 duration-500">
            <CheckCircle2 className="h-16 w-16 text-emerald-500 shadow-emerald-500/50" />
          </div>
          <p className="animate-in fade-in slide-in-from-bottom-2 text-2xl font-black tracking-tight text-emerald-500 duration-500">
            Payment Successful!
          </p>
        </>
      )}
      <p className="mt-2 text-sm text-gray-400">
        {status === "verifying"
          ? "Please do not close this window or refresh the page."
          : "Thank you for your generous contribution."}
      </p>
    </div>
  );
}
